import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-attachment-edit-modal',
  templateUrl: './attachment-edit-modal.component.html',
  styleUrls: ['./attachment-edit-modal.component.css']
})
export class AttachmentEditModalComponent implements OnInit {
  @Input() attachment: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveAttachment(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}
